'use client'

import Cookies from 'js-cookie'
import type { TenantConfig } from '@/types/tenant'

/**
 * Client-side utility to check if Snowplow tracking is disabled for the current tenant.
 * Reads the tenant config from the browser cookie set by the proxy middleware.
 */
export function getSnowplowDisabledFromCookies(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    const tenantConfigCookie = Cookies.get('tenant-config')
    if (!tenantConfigCookie) return false
    const config = JSON.parse(tenantConfigCookie) as TenantConfig
    return config?.snowplowDisabled === true
  } catch {
    return false
  }
}
